/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export enum FusenExecutionMode {
  NORMAL = "NORMAL",
  REDRIVE = "REDRIVE",
  REDRIVE_WITH_HIGHER_VERSION = "REDRIVE_WITH_HIGHER_VERSION",
}

export type CreateBulkRedriveWorkflowEntryInput = {
  redriveRequest: string;
  requestId: string;
  externalId?: string | null;
  workflowType?: string | null;
  sentToRedriveSQS?: boolean | null;
  eventVersionOverride?: number | null;
  fusenExecutionMode?: FusenExecutionMode | null;
  createNewWorkflow?: boolean | null;
  environment?: string | null;
  successfullySentToRedrive?: boolean | null;
  workflowStatus?: string | null;
  expirationDate?: number | null;
  sentToWorkflowStatusSQS?: boolean | null;
};

export type BulkRedriveWorkflowEntry = {
  __typename: "BulkRedriveWorkflowEntry";
  requestId: string;
  redriveRequest: string;
  externalId?: string | null;
  workflowType?: string | null;
  eventVersionOverride?: number | null;
  fusenExecutionMode?: FusenExecutionMode | null;
  createNewWorkflow?: boolean | null;
  environment?: string | null;
  sentToRedriveSQS?: boolean | null;
  successfullySentToRedrive?: boolean | null;
  workflowStatus?: string | null;
  expirationDate?: number | null;
  sentToWorkflowStatusSQS?: boolean | null;
};

export type UpdateBulkRedriveWorkflowEntryInput = {
  redriveRequest: string;
  requestId: string;
  externalId?: string | null;
  workflowType?: string | null;
  sentToRedriveSQS?: boolean | null;
  eventVersionOverride?: number | null;
  fusenExecutionMode?: FusenExecutionMode | null;
  createNewWorkflow?: boolean | null;
  environment?: string | null;
  successfullySentToRedrive?: boolean | null;
  workflowStatus?: string | null;
  expirationDate?: number | null;
  sentToWorkflowStatusSQS?: boolean | null;
};

export type CreateBulkRedriveWorkflowEntryMutationVariables = {
  input: CreateBulkRedriveWorkflowEntryInput;
};

export type CreateBulkRedriveWorkflowEntryMutation = {
  createBulkRedriveWorkflowEntry?: {
    __typename: "BulkRedriveWorkflowEntry";
    requestId: string;
    redriveRequest: string;
    externalId?: string | null;
    workflowType?: string | null;
    eventVersionOverride?: number | null;
    fusenExecutionMode?: FusenExecutionMode | null;
    createNewWorkflow?: boolean | null;
    environment?: string | null;
    sentToRedriveSQS?: boolean | null;
    successfullySentToRedrive?: boolean | null;
    workflowStatus?: string | null;
    expirationDate?: number | null;
    sentToWorkflowStatusSQS?: boolean | null;
  } | null;
};

export type UpdateBulkRedriveWorkflowEntryMutationVariables = {
  input: UpdateBulkRedriveWorkflowEntryInput;
};

export type UpdateBulkRedriveWorkflowEntryMutation = {
  updateBulkRedriveWorkflowEntry?: {
    __typename: "BulkRedriveWorkflowEntry";
    requestId: string;
    redriveRequest: string;
    externalId?: string | null;
    workflowType?: string | null;
    eventVersionOverride?: number | null;
    fusenExecutionMode?: FusenExecutionMode | null;
    createNewWorkflow?: boolean | null;
    environment?: string | null;
    sentToRedriveSQS?: boolean | null;
    successfullySentToRedrive?: boolean | null;
    workflowStatus?: string | null;
    expirationDate?: number | null;
    sentToWorkflowStatusSQS?: boolean | null;
  } | null;
};

export type GetBulkRedriveWorkflowEntriesQueryVariables = {
  requestId: string;
};

export type GetBulkRedriveWorkflowEntriesQuery = {
  getBulkRedriveWorkflowEntries?: Array<{
    __typename: "BulkRedriveWorkflowEntry";
    requestId: string;
    redriveRequest: string;
    externalId?: string | null;
    workflowType?: string | null;
    eventVersionOverride?: number | null;
    fusenExecutionMode?: FusenExecutionMode | null;
    createNewWorkflow?: boolean | null;
    environment?: string | null;
    sentToRedriveSQS?: boolean | null;
    successfullySentToRedrive?: boolean | null;
    workflowStatus?: string | null;
    expirationDate?: number | null;
    sentToWorkflowStatusSQS?: boolean | null;
  } | null> | null;
};
